import React, { Children, useEffect, useState } from 'react';
import { Item, ItemDefinition, registry, RenderProps } from '../Item';
import { DOORS, INFORMATION_DOOR, QUIZ_DOOR } from '../itemIds';
import { useSequenceStore } from '~/training/sequence/SequenceStore';
import { Wrapper } from './components/Wrapper';
import { x } from '@xstyled/styled-components';
import { Floor } from './components/Floor';
import { DoorsProvider, useDoorsStore } from './DoorsStore';
import { useEditorStore } from '~/shell/Store';
import styled from '@xstyled/styled-components';
interface Props {
  id: string;
  header?: { title: string[]; subtitle: string; icon: string };
}

export type DoorsDefinition = ItemDefinition<typeof DOORS, Props>;

export class Doors extends Item<typeof DOORS, Props> {
  protected render({ children, header }: RenderProps<Props>) {
    const { addBlocker } = useSequenceStore();
    const { setDoorIds } = useDoorsStore();
    const { editorMode } = useEditorStore();
    const childArray = Children.toArray(children) as React.ReactElement<{
      id?: string;
      type?: string;
    }>[];
    const isDoor = (c: React.ReactElement<{ type?: string }>) =>
      c?.props?.type === INFORMATION_DOOR || c?.props?.type === QUIZ_DOOR;
    const doorChildren = childArray.filter(isDoor);
    // Any non-door children (e.g. an instructional text list) are rendered just
    // above the doors instead of being mixed in with the door tiles.
    const instructionChildren = childArray.filter(c => !isDoor(c));
    const [showTooltip, setShowTooltip] = useState(true);

    useEffect(() => {
      if (!header) {
        const ids = doorChildren
          .map(c => c.props.id)
          .filter(Boolean) as string[];
        setDoorIds(ids);
        ids.forEach(id => addBlocker(id));
      }
    }, [header]);

    return (
      <DoorsProvider>
        <Wrapper header={header} bottomAligned={instructionChildren.length > 0}>
          {instructionChildren.length > 0 && (
            <x.div
              w="100%"
              display="flex"
              flexDirection="column"
              alignItems="center"
              zIndex={100}
              pb="12px"
            >
              {instructionChildren}
            </x.div>
          )}
          <x.ul position="relative">
            {doorChildren.map((c, i) => {
              const child = c as React.ReactElement<{ id?: string }>;
              const isMiddle = i === Math.floor(doorChildren.length / 2);
              return (
                <li
                  key={child?.props?.id ?? i}
                  style={{ position: 'relative' }}
                  onClick={() => {
                    if (!editorMode && isMiddle && showTooltip) {
                      setShowTooltip(false);
                    }
                  }}
                >
                  {c}
                </li>
              );
            })}
          </x.ul>
          <Floor />
        </Wrapper>
      </DoorsProvider>
    );
  }
}

registry[DOORS] = Doors;
